
interface HeaderItem {
  title: string;
  path: string;
}
export const headerMenu: HeaderItem[] = [
  {
    title: "Home",
    path: "https://www.theranostics.co.nz/",
  },
  {
    title: "Products",
    path: "https://www.theranostics.co.nz/products/",
  },
  {
    title: "Personalisation",
    path: "https://www.theranostics.co.nz/personalisation/",
  },
  {
    title: "How it works",
    path: "https://www.theranostics.co.nz/how-it-works/",
  },
  {
    title: "For Clinicians",
    path: "https://www.theranostics.co.nz/for-clinicians/",
  },
  {
    title: "FAQs",
    path: "https://www.theranostics.co.nz/faqs/",
  },
  {
    title: "About us",
    path: "https://www.theranostics.co.nz/about-us/",
  },
  {
    title: "Privacy",
    path: "https://www.theranostics.co.nz/privacy/",
  },
  {
    title: "Contact",
    path: "https://www.theranostics.co.nz/contact/",
  },
];
